import { Map } from 'immutable';
import { IChangeField } from '../../../utils/helpers/model.helper';
import {
  entityKeys,
  entityModelFactory,
  generateContent,
  getInContent,
} from '../../entity-data/entity.model';
import { DocumentTypesEnum } from '../document-data.data';
import { Billing } from './billing.model';

const PARENT_SCHEMA = Object.freeze({
  REFERENCE_LOCAL_ID: '',
});
const CONTENT_SCHEMA = Object.freeze({
  DOC_DATE: '', // i2g-timezoneless-date (yyyy-mm-dd)
  DOC_NUMBER: null, // ''
  BILLING: Billing,
});
const KEYS = entityKeys(PARENT_SCHEMA, CONTENT_SCHEMA);
const CONTENT_KEYS = generateContent(CONTENT_SCHEMA).KEYS;
const contentChanges = (contentProps: Map<string, any>): IChangeField[] => {
  return [
    {
      key: CONTENT_KEYS.BILLING,
      value: new Billing(getInContent(contentProps, CONTENT_KEYS.BILLING)),
    },
  ];
};

export class DocumentPreview extends entityModelFactory(
  PARENT_SCHEMA,
  null,
  CONTENT_SCHEMA,
  contentChanges
) {
  static KEYS: any = KEYS;
  static CONTENT_KEYS: any = CONTENT_KEYS;

  get documentType(): DocumentTypesEnum {
    return this.header.type as DocumentTypesEnum;
  }

  get isSynced(): boolean {
    return this.header.state === 'synced';
  }

  get isDeleted(): boolean {
    return this.header.state === 'deleted';
  }

  get billingName(): string {
    return this.billing.name;
  }

  get billingEmail(): string {
    return this.billing.email;
  }

  get docNumber(): string {
    return this.getFieldInContent(CONTENT_KEYS.DOC_NUMBER);
  }

  get billing(): Billing {
    return this.getFieldInContent(CONTENT_KEYS.BILLING);
  }

  get docDate(): string {
    return this.getFieldInContent(CONTENT_KEYS.DOC_DATE);
  }
}
